seedWebApp.controller('RefersController', ['$scope', '$rootScope', '$uibModal', 'ToastService', 'TranslationService', 'MaterialService',
    function ($scope, $rootScope, $uibModal, ToastService, TranslationService, MaterialService) {

        $scope.translation = TranslationService.getActiveTranslation();
        $scope.prefs = {
            name: 'RefersGrid',
            sortByCol: null,
            canAdd: false,
            canEdit: true,
            canDelete: false,
        };

        $scope.columns = [
            { name: 'ReferID', display: 'ID', orderBy: 'asc', editable: false, width: 10, isKey: true },  //filterOptions: [] 
            { name: 'ReferName', display: 'Referência', editable: true, width: 25 },
            { name: 'ReferDescription', display: 'Descrição', editable: true, width: 15 },
            { name: 'ReferLength', display: 'Comprimento', filterOptions: [], editable: true, width: 15 },
            { name: 'IsSubproduct', display: 'Subproduto', filterOptions: [], editable: true, width: 15, dataType: 'boolean' },
        ];


        $scope.prefs.sortByCol = $scope.columns[0];
        $scope.prefs.sortByCol.orderReverse = false;

        $scope.loadService = MaterialService.getRefers;
        $scope.resetService = MaterialService.resetCache;
        //$scope.loadColumns = ContactService.getContactsColumns;

        $scope.getTotal = function () {
            $scope.loadingTotal = true;
            MaterialService.getRefersCount().then(function (response) {
                $scope.loadingTotal = false;
                if (response) {
                    $scope.totalItems = response.data.TotalCount;
                    $scope.lastSync = response.data.LastSync;
                }

            });
        };

        $scope.getTotal();

        $scope.searchMode = function () {
            $scope.$broadcast('inputSearch', $scope.filterString);
        };

        $scope.doRefresh = function () {
            $scope.$broadcast('refreshServiceGrid');
        };

        $scope.toExcel = function () {
            $scope.$broadcast('toExcel', 'refers');
        };

        $scope.doInsert = function () {
            $scope.$broadcast('addItem');
        };

        //$(document).ready(function () {
        //    $scope.overflowSize = $scope.AdjustSize();
        //});
    }]
);
